// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"C1-z","displaySixCardTiles":"D1-z"};